import { of as observableOf } from "rxjs";
import { distinctUntilChanged, map, first, mergeMap } from "rxjs/operators";
import { GeoCoords } from "../geo/GeoCoords";
export class CampaignService {
    constructor(stateService, api, graphService, jumpNodeCalculator) {
        this._api = api;
        this._stateService = stateService;
        this._graphService = graphService;
        this._currentNode$ = this._stateService.currentNode$;
        this._geoCoords = new GeoCoords();
        this._jumpNodeCalculator = jumpNodeCalculator;
        this._currentCampaigns$ = this._currentNode$.pipe(mergeMap((node) => this._cacheCampaigns$(node)), map((nodes) => {
            const campaigns = nodes.reduce((r, a) => {
                if (r.map((x) => x.id).indexOf(a.frame.campaignID) == -1)
                    r.push(a.frame.campaign);
                return r;
            }, []);
            return campaigns;
        }), distinctUntilChanged((c_prev, c) => {
            const ids_prev = c_prev.map((x) => x.id);
            const ids = c.map((x) => x.id);
            const descriptions_prev = c_prev.map((x) => x.description);
            const descriptions = c.map((x) => x.description);
            const eq_to_idsprev = ids_prev.every((val) => {
                return ids.indexOf(val) > -1;
            });
            const eq_to_ids = ids.every((val) => {
                return ids_prev.indexOf(val) > -1;
            });
            const eq_to_descriptions_prev = descriptions_prev.every((val) => {
                return descriptions.indexOf(val) > -1;
            });
            const eq_to_descriptions = descriptions.every((val) => {
                return descriptions_prev.indexOf(val) > -1;
            });
            return eq_to_ids && eq_to_idsprev && eq_to_descriptions_prev && eq_to_descriptions;
        }));
    }
    get campaigns$() {
        return this._currentCampaigns$;
    }
    _cacheCampaigns$(node) {
        const sw = this._geoCoords.enuToGeodetic(-20, -20, 0, node.latLon.lat, node.latLon.lon, 0);
        const ne = this._geoCoords.enuToGeodetic(20, 20, 0, node.latLon.lat, node.latLon.lon, 0);
        return this._graphService.cacheBoundingBox$({ lat: sw[0], lon: sw[1] }, { lat: ne[0], lon: ne[1] }).pipe(map((nodes) => {
            return nodes.filter((x) => x.frame.collection == node.frame.collection);
        }));
    }
    moveToCampaign$(campaignID) {
        return this._currentNode$.pipe(first(), mergeMap((node) => this._cacheCampaigns$(node)), map((allnodes) => allnodes.filter((node_candidate) => node_candidate.frame.campaignID == campaignID)), mergeMap((filtered_nodes) => {
            if (filtered_nodes.length > 0)
                return this._currentNode$.pipe(first(), map((node) => {
                    const potential_nodes = this._jumpNodeCalculator.getPotentialJumpNodes(filtered_nodes, node, node.latLon);
                    return this._jumpNodeCalculator.computeSimilarNode(potential_nodes, true);
                }));
            return observableOf(undefined);
        }));
    }
}
//# sourceMappingURL=CampaignService.js.map